import {Injectable, Input} from '@angular/core';
import * as SpinnerReducer from '../../store/spinner/reducers';
import {Store} from '@ngrx/store';
import {User} from '@models/user';
import * as AuthReducer from '../../store/auth/reducers';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Subscription} from '@models/subscription';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  user: User;
  constructor(
    private httpClient: HttpClient,
    private authStore: Store<AuthReducer.AuthState>,
    private spinnerStore: Store<SpinnerReducer.SpinnerState>
  ) {
    this.authStore.subscribe(
      (val) => {
        const auth = val.auth;
        if (auth && auth.user) {
          this.user = auth.user;
        }
      }
    );
  }

  getAll(program_id, user_id = null) {
    let params = '';
    if (Array.isArray(program_id)) {
      params += 'ids=' + program_id.join(',');
    }
    if (user_id) {
      params += '&user_id=' + user_id;
    }
    if (Array.isArray(program_id)) {
      return this.httpClient.get('subscription/program?' + params);
    } else {
      return this.httpClient.get('subscription/' + program_id + '?' + params);
    }
  }

  /**
   * Get subscriptions by school Id
   *  Param 'schoolId' is used for not authenticated queries
   * @param schoolId
   * @param types
   */
  getByschool(schoolId = null, types = []) {
    const school_id = this.user && this.user.activeSchool ? this.user.activeSchool : schoolId;
    if (school_id) {
      const prefix = schoolId ? 'school/' : '';
      let typesQ = '';
      if (types.length > 0) {
        typesQ += '?withTypes=' + types.join(',');
      }
      return this.httpClient.get(prefix + school_id + (prefix.length === 0 ? '/subscription/school' : '/subscription') + typesQ);
    }
    return new Observable();
  }
  getByUser(user_id) {
    return this.httpClient.get('subscription/byUser/' + user_id);
  }
  create(body: Subscription) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.post(school_id + '/subscription', body);
    }
    return new Observable();
  }
  edit(body: Subscription) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.put(school_id + '/subscription/' + body.id, body);
    }
    return new Observable();
  }
  editUserSubscription(body: {user_subscription_id: number, discount_value: number, discount_value_name: string}) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.put(school_id + '/subscription/user', body);
    }
    return new Observable();
  }
  addUser(body: {user_id: number, subscription_id: number, program_id: number, selected_date?: string}) {
    return this.httpClient.post('subscription/user', body);
  }
  deleteUser(body: {user_id: number, subscription_id: number}) {
    return this.httpClient.delete('subscription/user/' + body.user_id + '/' + body.subscription_id);
  }
  toggleUserSubscription(body, deleteUser = false, private_class = false) {
    if (deleteUser === true) {
      return this.deleteUser(body);
    } else if (private_class){
      return this.sendRequestLimitedClass(body);
    } else {
      return this.addUser(body);
    }
  }
  addProgram(body: {program_id: number, subscription_id: number, toggle: boolean}) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.post(school_id + '/subscription/program', body);
    }
    return new Observable();
  }
  sendRequestLimitedClass(body: {subscription_id: number, user_id: number, program_id: number}) {
    return this.httpClient.post('subscription/requestLimitedClass', body);
  }
  suspendSubscription(body: {program_id: number, subscription_id: number, user_id: number, type: string}) {
    body.type = 'suspend';

    return this.httpClient.post('subscription/toggleStatus', body);
  }
  toggleSubscriptionStatus(body: {program_id: number, subscription_id: number, user_id: number, type: string}) {
    return this.httpClient.post('subscription/toggleStatus', body);
  }
  getSubscriptionUsers(subscriptions_ids = [], programIds = []) {
    if (subscriptions_ids.length > 0) {
      const idsStr = subscriptions_ids.join(',');
      const programIdsStr = programIds.join(',');
      let url = `subscription/subscriptionStudents?ids=${idsStr}`;

      if (programIds.length > 0) {
        url += `&programIds=${programIdsStr}`;
      }

      return this.httpClient.get(url);
    }

    return new Observable();
  }
  getSubscriptionUsersList(subscriptionId, programId = null) {
    let url = `subscription/${subscriptionId}/subscriptionStudentsList`;
    if (programId) {
      url += `?program_id=${programId}`;
    }

    return this.httpClient.get(url);
  }
  checkSubscriptionExist(programId: number, userId: number) {
    return this.httpClient.get('subscription/exist/' + programId + '/' + userId);
  }
  removeSubscription(body: Subscription) {
    if (this.user.activeSchool) {
      const schoolId = this.user.activeSchool;
      return this.httpClient.delete(`${schoolId}/subscription/${body.id}`);
    }
    return new Observable();
  }
  getByType(name: string, school_id = null) {
    school_id = school_id ? school_id : this.user.activeSchool;
    if (school_id) {
      return this.httpClient.get(`subscription/type/${name}?schoolId=${school_id}`);
    }
    return new Observable();
  }

  createSub(body: any) {
    // this.spinnerStore.dispatch(new StartSpinner());
    return this.httpClient.post('subscription/createSubscription', body);
  }

  updateSub(body: any) {
    // this.spinnerStore.dispatch(new StartSpinner());
    return this.httpClient.post('subscription/updateSubscription', body);
  }

  removeSub(body: {id: number}) {
    return this.httpClient.delete('subscription/destroySubscription/'+ body.id);
  }

  getAllSub() {
    return this.httpClient.get('subscription/allSubscription');
  }

  getAdminSubById(id: number) {
    return this.httpClient.get(`subscription/viewSubscription/${id}`);
  }

  getAdminSubTrialById(id: number) {
    return this.httpClient.get(`subscription/viewSubscription/${id}/trial`);
  }

  createScenario(body: any) {
    // this.spinnerStore.dispatch(new StartSpinner());
    return this.httpClient.post('scenario/createScenario', body);
  }

  updateScenario(body: any) {
    // this.spinnerStore.dispatch(new StartSpinner());
    return this.httpClient.post('scenario/updateScenario', body);
  }

  // used same endpoint as for school terms
  updateTermsFile(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('terms', fileToUpload, fileToUpload.name);

    return this.httpClient.post(`school/termsUpload`, formData);
  }

  removeScenario(body: {id: number}) {
    return this.httpClient.delete('scenario/destroyScenario/'+ body.id);
  }

  getAllScenario() {
    return this.httpClient.get('scenario/allScenario');
  }

  getScenarioById(id: number) {
    return  this.httpClient.get('scenario/viewScenario/' + id);
  }

  getAuthedOwnerSubscription() {
    return this.httpClient.get('subscription/owner');
  }

  cancelAuthedOwnerSubscription() {
    return this.httpClient.delete('subscription/owner');
  }

  getCommercialPipeline() {
    return this.httpClient.get('admin/school-commercial-pipeline');
  }
}
